// Re-exposes the `uuid/v4` deep-import path removed from uuid@9's `exports`.
// eslint-disable-next-line no-restricted-imports -- the point of this shim
import { v4 } from 'uuid';

// Loaded through Vite aliases, which static analysis cannot trace.
// fallow-ignore-next-line unused-export
export default v4;
// fallow-ignore-next-line unused-export
export { v4 };
